(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mcs-slider')) {
    class McsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dotsWrap = this.querySelector('[data-dots]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.pauseBtn = this.querySelector('[data-pause]');

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
        this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.hovering = false;
        this.focused = false;
        this.inView = true;
        this.userPaused = false;
        this.editorHold = false;
        this.timer = null;
        this.raf = null;

        if (!this.track || !this.slides.length) return;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.updateDots(); });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.resizeObs = new ResizeObserver(() => { this.buildDots(); this.updateDots(); this.sync(); });
        this.resizeObs.observe(this.track);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.sync(); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.sync(); });

        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => {
            this.userPaused = !this.userPaused;
            this.toggleAttribute('data-paused', this.userPaused);
            this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play autoplay' : 'Pause autoplay');
            this.sync();
          });
        }

        this.onEnter = () => { if (this.pauseOnHover) { this.hovering = true; this.sync(); } };
        this.onLeave = () => { this.hovering = false; this.sync(); };
        this.onFocusIn = () => { this.focused = true; this.sync(); };
        this.onFocusOut = () => { this.focused = false; this.sync(); };
        this.onTouchEnd = () => this.sync(); // restart the full delay after a swipe
        this.onVisibility = () => this.sync();

        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.track.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);

        this.viewObs = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.2 });
        this.viewObs.observe(this);

        // Theme editor: jump to the selected slide and hold autoplay while editing it
        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.editorHold = true; this.goTo(Math.min(i, this.maxIndex())); this.sync(); }
        };
        this.onBlockDeselect = () => { this.editorHold = false; this.sync(); };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.buildDots();
        this.updateDots();
        this.sync();
      }

      disconnectedCallback() {
        this.stop();
        if (this.resizeObs) this.resizeObs.disconnect();
        if (this.viewObs) this.viewObs.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      perView() {
        const s = this.slides[0];
        if (!s) return 1;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return Math.max(1, Math.round((this.track.clientWidth + gap) / (s.offsetWidth + gap)));
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.perView());
      }

      current() {
        const left = this.track.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        this.slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - left);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return Math.min(best, this.maxIndex());
      }

      goTo(i) {
        const target = this.slides[Math.max(0, Math.min(i, this.slides.length - 1))];
        if (!target) return;
        this.track.scrollTo({ left: target.offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
      }

      next() {
        const i = this.current();
        this.goTo(i >= this.maxIndex() ? 0 : i + 1);
      }

      prev() {
        const i = this.current();
        this.goTo(i <= 0 ? this.maxIndex() : i - 1);
      }

      buildDots() {
        const max = this.maxIndex();
        this.toggleAttribute('data-static', max === 0);
        if (!this.dotsWrap) return;
        const count = max + 1;
        if (this.dotsWrap.children.length === count) return;
        this.dotsWrap.innerHTML = '';
        for (let i = 0; i < count; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mcs__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => { this.goTo(i); this.sync(); });
          this.dotsWrap.appendChild(b);
        }
      }

      updateDots() {
        if (!this.dotsWrap) return;
        const i = this.current();
        Array.from(this.dotsWrap.children).forEach((d, n) => {
          if (n === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      shouldRun() {
        return this.autoplay && !this.reduced && !this.userPaused && !this.hovering &&
          !this.focused && this.inView && !this.editorHold && !document.hidden &&
          this.maxIndex() > 0;
      }

      stop() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
      }

      sync() {
        this.stop();
        if (this.shouldRun()) {
          this.timer = setInterval(() => this.next(), this.speed);
        }
      }
    }
    customElements.define('mcs-slider', McsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
